import cx from 'classnames';
import React, { CSSProperties, LegacyRef, PropsWithChildren } from 'react';
import styles from './Tooltip.mscss';

export type Placement = 'top' | 'right' | 'bottom' | 'left';

interface OwnProps {
    className?: string;
    style?: CSSProperties;
    placement?: Placement;
    containerRef?: LegacyRef<HTMLDivElement>;
    arrowRef?: LegacyRef<HTMLDivElement>;
    arrowStyle?: CSSProperties;
}

type Props = OwnProps;

const Tooltip: React.FunctionComponent<Props> = ({
    className,
    placement = 'right',
    containerRef,
    arrowRef,
    arrowStyle,
    style,
    children,
}) => {
    return (
        <div
            className={cx(styles.Tooltip, styles[`Tooltip--${placement}`], className)}
            style={style}
            ref={containerRef}
        >
            <div ref={arrowRef} className={styles.Tooltip__arrow} style={arrowStyle} />
            <div className={styles.Tooltip__inner}>{children}</div>
        </div>
    );
};

Tooltip.displayName = 'Tooltip';

export default React.memo<PropsWithChildren<Props>>(Tooltip);
